<template>

    <div class="settings__item data-card block">
        <div class="data-card__head">
            <div class="data-card__title">
                <span class="data-card__label">Доп. адрес электронной почты:</span>
                <span class="data-card__value">{{user.ExtraEmail}}</span>
            </div>
            <div class="data-card__link">
                <a href="#dataCard_21" class="link link--present" data-toggle="collapse"><span class="link__text">Изменить</span></a>
            </div>
        </div>
        <div id="dataCard_21" class="data-card__form accordion-body collapse">
            <div class="data-card__inner accordion-body__inner">
                <div class="b-form-sm">
                    <div class="b-form-sm__body">
                        <div class="b-form-sm__item">
                            <label class="txt-input">
                                <div class="txt-input__input">
                                    <input class="txt-input__field input"
                                           :class="!$v.newEmail.emailType ? 'is-error' : ''" 
                                           type="text"
                                           :placeholder="user.ExtraEmail ? user.ExtraEmail : 'Доп. E-mail'"
                                           v-model="newEmail">
                                </div>
                            </label>
                        </div>
                        <div class="b-form-sm__item">
                            <a class="button button--th-second"
                               :class="!$v.newEmail.emailType || isEqualUserData ? 'disabled' : ''"
                               v-on:click="changeExtraEmail">Сохранить</a>
                            <a href="#dataCard_21" class="button button--th-link" data-toggle="collapse">Отменить</a>
                        </div>
                    </div>

                    <div class="txt-input__required txt-input__required--error error-block">{{validateEmailTypeText}}</div>

                    <div class="txt-input__required" :class="isValidateErrors ? 'error-block' : 'validated-block'">{{serverResponseText}}</div>

                    <div class="data-card__caption validated-block">
                        Данный адрес используется в качестве дополнительного
                    </div>

                </div>
            </div>
        </div>

    </div>

</template>

<script>
    const { required } = window.validators
    const { validationMixin, Vuelidate } = window.vuelidate

    export default {
        mixins: [validationMixin],
        props: ['user'],
        data: function () {
            return {
                newEmail: this.user.ExtraEmail ? this.user.ExtraEmail : '',
                isServerVerify: false,
                isValidateErrors: false,
                serverMessage: [],
                serverResponse: '',
            }
        },
        computed: {
            validateEmailTypeText: function () {
                return !this.$v.newEmail.emailType || this.newEmail == '' ? 'Недопустимые символы в E-mail адресе' : ' ';
            },
            serverResponseText: function () {
                return this.serverMessage ? this.serverMessage[0] : '';
            },
            isEqualUserData: function () {
                return this.user.ExtraEmail == this.newEmail;
            }
        },
        watch: {
            newEmail: function () {
                if (this.newEmail.length >= 1) {
                    this.serverMessage = [];
                    this.isServerVerify = false;
                }

               this.newEmail = this.newEmail.trim();
            },
            isValidateErrors: function (isValidateErrors) {
                if (!isValidateErrors) {
                    this.serverMessage = [];
                }
            },
            serverResponse: function (serverResponse) {
                this.serverMessage = serverResponse.message;

                if (serverResponse.isSuccess) {
                    this.updateExtraEmail(this.newEmail);
                    this.isValidateErrors = false;
                    this.isServerVerify = true;
                } else {
                    this.isValidateErrors = true;
                    this.isServerVerify = false;
                } 
            }
        },
        validations: {
            newEmail: {
                required: required,
                emailType: function (value) {
					return value.match('\\w+([-+.]\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*') ? true : false;
                }
            }
        },
        methods: {
            changeExtraEmail: function () {
                var self = this;
                this.isValidateErrors = false;

                axios.post('/Profiles/ChangeExtraEmail', {
                    CurrentUserName: self.user.UserName,
                    ExtraEmail: self.newEmail.trim(),
                })
                    .then(function (response) {
                        self.serverResponse = response.data;
                        document.querySelector('html').classList.remove('is-lock');
                    })
                    .catch(function (error) {
                        console.log(error)
                        self.isValidateErrors = true;
                        self.serverMessage = ['Изменение email невозможно, попробуйте позже']
                    });
            },
            updateExtraEmail: function (email) {
                this.$emit('update', email);
                this.isValidateErrors = false;
                this.serverMessage = ['Email успешно изменен']
            }
        }
    }

</script>


// WEBPACK FOOTER //
// Scripts/app/profiles/components/ChangeExtraEmail.vue